<template>
    <div class="container-fluid mt-4">
        <div v-if="loader" id="loader"></div>
        <div class="row" id="quiz-creator-component">
            <div class="col-12">
                <h2 v-if="!form.id">{{ trans('quiz-creator.quiz_creator') }}</h2>
                <form class="ml-3">
                    <div class="row">
                        <div class="col-12 position-relative">
                            <!--                            <a @click="toggleDescription()" class="pointer float-right description-link-quiz"  data-toggle="tooltip" data-placement="top" :title="trans('quiz-creator.quiz_description')"><img width="23" :src="'/images/marLMS-description-without-frame.png'"></a>-->
                            <template v-if="openDescription">
                                <div class="form-check">
                                    <input :id="'show-description'+form.id" @change="change"
                                           v-model="form.showDescription"
                                           class="form-check-input" type="checkbox">
                                    <label class="form-check-label" :for="'show-description'+form.id"
                                           style="display: inline-block">
                                        <template v-if="form.id && form.quiz_type != 'essay'">
                                            {{ trans('quiz-creator.show_description_in_quiz') }}
                                        </template>
                                        <template v-else>
                                            {{ trans('quiz-creator.show_description_in_essay') }}
                                        </template>
                                    </label>
                                </div>
                                <div class="mb-5">
                                    <inline-editor :type="'quiz'" :quizId="form.id"
                                                   :quizContent="form.quizBlocks"
                                                   :sid="sid"
                                                   :sections="sections"
                                                   @update-content="updateBlocks"
                                    />
                                </div>
                            </template>

                            <div class="w-layout-grid quiz-grid mb">
                                <div v-if="form.id && form.quiz_type != 'essay'">
                                    <div class="field-label mb-1">{{ trans('quiz-creator.quizType') }}:</div>
                                    <div>
                                        <a @click="changeQuizType('quiz')" class="btn active mr-3 w-button"
                                           :class="form.quiz_type != 'quiz' ? 'grey' : ''">{{
                                                trans('quiz-creator.quiz')
                                            }}</a>
                                        <a @click="changeQuizType('exam')" class="btn active inactive w-button"
                                           :class="form.quiz_type != 'exam' ? 'grey' : ''">{{
                                                trans('quiz-creator.exam')
                                            }}</a>
                                    </div>
                                </div>
                                <div v-if="form.quiz_type != 'essay'">
                                    <div class="field-label mb-1">{{ trans('quiz-creator.quizRetakes') }}</div>
                                    <select @change="change" v-model="form.repeat_times" class="form-control"
                                            id="repeat-q">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="0">{{ trans('quiz-creator.quiz_dropdown_unlimited') }}</option>
                                    </select>
                                </div>
                                <div v-if="form.id">
                                    <div class="field-label mb-1">{{ trans('quiz-creator.quizMinScore') }}</div>
                                    <div class="input-group">
                                        <input v-model="form.min_score"
                                               type="number"
                                               @change="change"
                                               @input="fixMinScore"
                                               class="form-control medium"
                                               :class="{'is-invalid': form.quiz_type !== 'essay' && form.min_score_type === 'points' && questionPoints < form.min_score}"
                                               aria-label="Text input with dropdown button">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary dropdown-toggle text-capitalize"
                                                    type="button" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                {{ trans('quiz-creator.' + form.min_score_type) }}
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item pointer"
                                                   @click="form.min_score_type='percent'; change()">{{
                                                        trans('quiz-creator.percent')
                                                    }}</a>
                                                <a class="dropdown-item pointer"
                                                   @click="form.min_score_type='points'; change()">{{
                                                        trans('quiz-creator.points')
                                                    }}</a>
                                            </div>
                                        </div>
                                        <span v-if="form.min_score_type === 'points' && questionPoints < form.min_score"
                                              class="invalid-feedback"
                                              role="alert">{{ trans('quiz-creator.minPointsTooBig') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 mt-1" v-if="form.id">
                                <div class="col-6">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="col-12 form-check mb-1" v-if="form.quiz_type != 'essay'">
                                                <input @change="change" v-model="form.show_solutions"
                                                       class="form-check-input" type="checkbox"
                                                       :id="'show_solutions'+form.id">
                                                <label class="form-check-label" :for="'show_solutions'+form.id">
                                                    {{ trans('quiz-creator.show_solution') }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-check mb-1">
                                                <input @change="change" v-model="form.is_private"
                                                       class="form-check-input" type="checkbox"
                                                       id="is_private">
                                                <label class="form-check-label" for="is_private">
                                                    {{ trans('quiz-creator.is_private') }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-check mb-1">
                                                <input @change="change" v-model="form.required_graduation"
                                                       class="form-check-input" type="checkbox"
                                                       :id="'required_graduation_'+form.id">
                                                <label class="form-check-label" :for="'required_graduation_'+form.id">
                                                    {{ trans('quiz-creator.RequiredForGraduation') }}
                                                </label>
                                            </div>
                                        </div>
                                        <template v-if="form.quiz_type == 'exam'">
                                            <div class="col-12">
                                                <div class="form-check mb-1">
                                                    <input @change="change" v-model="form.show_exam_in_content"
                                                           class="form-check-input" type="checkbox"
                                                           :id="'show_exam_in_content'+form.id">
                                                    <label class="form-check-label"
                                                           :for="'show_exam_in_content'+form.id">
                                                        {{ trans('quiz-creator.show_exam_in_content') }}
                                                    </label>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-check mb-1">
                                                <input @change="change" v-model="form.exam_set_clock"
                                                       class="form-check-input" type="checkbox"
                                                       :id="'exam_set_clock_'+form.id">
                                                <label class="form-check-label" :for="'exam_set_clock_'+form.id">
                                                    {{ trans('quiz-creator.set_time') }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div v-if="form.exam_set_clock" class="form-group mb-2">
                                                <input :placeholder="trans('quiz-creator.placehoder.time_in_minutes')"
                                                       min="1" type="number" @change="change" v-model="form.time"
                                                       class="form-control" id="time">
                                            </div>
                                            <div class="form-group">
                                                <label class="form-check-label" for="delay_results_for">
                                                    {{ trans('quiz-creator.delay_results_for_minutes') }}
                                                </label>
                                                <input @change="change" v-model="form.delay_results_for_minutes"
                                                       class="form-control" type="number" min="0" step="1"
                                                       id="delay_results_for">
                                            </div>
                                        </div>
                                        <div class="col-6"></div>
                                        <template v-if="form.quiz_type == 'exam'">
                                            <div class="col-12">
                                                <div class="form-check mb-1">
                                                    <input @change="change" v-model="form.exam_trainer_close"
                                                           class="form-check-input" type="checkbox"
                                                           :id="'exam_trainer_close'+form.id">
                                                    <label class="form-check-label" :for="'exam_trainer_close'+form.id">
                                                        {{ trans('quiz-creator.trainer_close_exam_mannually') }}
                                                    </label>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="showSection && form.quiz_type != 'essay'">
                        <div class="tabs-menu w-tab-menu" role="tablist">
                            <a data-w-tab="Tab 1" class="tab-link large w-inline-block w-tab-link w--current"
                               id="w-tabs-3-data-w-tab-0" href="#w-tabs-3-data-w-pane-0" role="tab"
                               aria-controls="w-tabs-3-data-w-pane-0" aria-selected="true">
                                <div class="content-icon-wrap">
                                    <img :src="'/images/marLMs-questions-grey.png'" loading="lazy" alt=""
                                         class="inactive-icon" style="opacity: 0;">
                                    <img :src="'/images/marLMs-questions-orange.png'" loading="lazy" alt=""
                                         class="active-icon" style="opacity: 1;">
                                </div>
                                <div>{{ trans('quiz-creator.Questions') }}</div>
                            </a>
                        </div>
                        <draggable
                            :clone="cloneSection"
                            tag="div"
                            :group="{ name: 'questions',
                            pull: 'clone',
                            put: false }"
                            :list="questionsTypes"
                            class="mb-3 sticky-col">
                            <div
                                v-if="(element.type != 'essay' && form.quiz_type != 'essay') || element.type == 'essay' && form.quiz_type == 'essay' "
                                class="d-inline-block mr-2" v-for="(element, idx) in questionsTypes" :key="element.id">
                                <div class="pl-0 pr-0 ml-2 mr-2" data-toggle="tooltip" data-placement="top"
                                     :title="element.name">
                                    <div class="mt-3 course-icon-wrap hover-image">
                                        <img :src="element.class" style="opacity: 1;" loading="lazy"
                                             class="quiz-drag-icon inactive-icon">
                                        <img :src="element.active" style="opacity: 0;" loading="lazy"
                                             class="quiz-drag-icon active-icon">
                                    </div>
                                </div>
                            </div>
                        </draggable>
                    </template>
                    <template v-if="showSection && form.quiz_type != 'essay'">
                        <h4> {{ trans('quiz-creator.content') }}</h4>
                        <small id="emailHelp"
                               class="form-text text-muted">{{ trans('quiz-creator.drag_and_drop_message') }}</small>
                        <draggable handle=".handle"
                                   @change="change"
                                   :swapThreshold="0.5"
                                   :scroll="true"
                                   :scroll-speed="2000"
                                   :scroll-sensitivity="10"
                                   tag="div" group="questions"
                                   :list="questions"
                                   class="course-section-area"
                                   :class="!questions.length ? 'empty-section-area' : '' ">
                            <div v-for="(element, idx) in questions" :key="idx" class="position-relative">
                                <template>
                                    <div class="creator-block" :id="'lesson-'+ element.id">
                                        <div class="creator-block-top">
                                            <div class="course-icon-wrap handle hover-image">
                                                <img :src="'/images/drag-grey.png'" loading="lazy" alt=""
                                                     class="inactive-icon" style="opacity: 1;">
                                                <img :src="'/images/drag-orange.png'" loading="lazy" alt=""
                                                     class="active-icon" style="opacity: 0;">
                                            </div>
                                            <div class="text-field-wrap">
                                                <input @change="change(false,false, false)" @focusin="openEditor(idx)"
                                                       type="text" v-model="questions[idx].name" class="form-control"
                                                       :placeholder="getQuestionName(questions[idx].type)">
                                            </div>
                                            <div v-if="!['essay','content'].includes(element.type)"
                                                 @click="toggleEditor(element.id, idx)"
                                                 class="course-icon-wrap mr hover-image">
                                                <img
                                                    :src="'/images/svg-icons/marlms-build-quiz.svg'"
                                                    alt=""
                                                    class="inactive-icon svg-with-hover"
                                                    :class="{'active': element.showQuestions}"
                                                    loading="lazy"
                                                    style="opacity: 1;"
                                                />
                                            </div>
                                            <div class="course-icon-wrap mr hover-image">
                                                <img v-if="element.show_title" @click="showQuestionTitle(idx, element)"
                                                     :src="'/images/eye-grey.png'" loading="lazy" alt=""
                                                     class="inactive-icon">
                                                <img v-else @click="showQuestionTitle(idx, element)"
                                                     :src="'/images/hidden-red.png'" loading="lazy" alt=""
                                                     class="inactive-icon">
                                            </div>
                                            <div class="w-dropdown" style="">
                                                <div class="course-icon-wrap hover-image">
                                                    <img :src="'/images/marlms-more-grey.png'" loading="lazy" alt=""
                                                         class="inactive-icon" style="opacity: 1;">
                                                    <img :src="'/images/marlms-more-orange.png'" loading="lazy" alt=""
                                                         class="active-icon" style="opacity: 0;">
                                                </div>
                                                <nav class="dropdown-list w-dropdown-list custom-dropdown" id="w-dropdown-list-10"
                                                     aria-labelledby="w-dropdown-toggle-10">
                                                    <a @click="toggleQuestionDescription(idx)"
                                                       class="action-link w-inline-block" tabindex="0">
                                                        <div class="dropdown-icon-wrap mr">
                                                            <img :src="'/images/marLMS-description-grey.png'"
                                                                 loading="lazy" alt="" class="inactive-icon">
                                                            <img :src="'/images/marLMS-description-grey.png'"
                                                                 loading="lazy" alt="" class="active-icon"
                                                                 style="opacity: 0;">
                                                        </div>
                                                        <div>{{ trans('quiz-creator.showDescription') }}</div>
                                                    </a>
                                                    <a @click="removeSection(idx,$event)"
                                                       :data-confirm-title="trans('messages.remove_quiz_element_confirm_dialog_title')"
                                                       :data-confirm-message="trans('messages.remove_quiz_element_confirm_dialog_message')"
                                                       class="action-link delete w-inline-block" tabindex="0">
                                                        <div class="dropdown-icon-wrap mr">
                                                            <img :src="'/images/delete-red.png'" loading="lazy" alt=""
                                                                 class="inactive-icon">
                                                            <img :src="'/images/delete-red.png'" loading="lazy" alt=""
                                                                 class="active-icon" style="opacity: 0;">
                                                        </div>
                                                        <div>{{ trans('quiz-creator.deleteQuestion') }}</div>
                                                    </a>
                                                </nav>
                                            </div>
                                        </div>
                                        <div v-if="element.showQuestions" class="creator-block-bottom"
                                             :id="'editor-'+element.id">
                                            <div v-if="form.min_score_type !== 'percent'">
                                                <label
                                                    class="field-label mb-1">{{
                                                        trans('quiz-creator.question_points')
                                                    }}</label>
                                                <div class="mb-3 d-flex align-items-center">
                                                    <input :disabled="form.min_score_type == 'percent'"
                                                           @change="saveQuestion(element)" type="number" min="0"
                                                           v-model="element.points" class="form-control" style="width: 75px">
                                                    <div class="ml-2 text-center justify-content-center">
                                                        / {{ questionPoints }} (min: {{ form.min_score }})
                                                    </div>
                                                </div>

                                            </div>
                                            <template v-if="element.type!='content'">
                                                <responses-form :qId="form.id" :questionId="element.id"
                                                                :type="element.type"></responses-form>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <ckeditor :editor="editor"
                                                              class="editor-border" v-model="questions[idx].description"
                                                              @blur="change" :config="editorConfig"></ckeditor>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="creator-block-bottom" v-if="element.contentOpen">
                                            <label>
                                                {{ trans('quiz-creator.question_description') }}
                                                <i v-if="element.show_description"
                                                   @click="showQuestionDescription(idx, element)" data-toggle="tooltip"
                                                   data-placement="top"
                                                   :title="trans('quiz-creator.show_hide_question_description')"
                                                   class="pointer far fa-eye "></i>
                                                <i v-if="!element.show_description"
                                                   @click="showQuestionDescription(idx, element)" data-toggle="tooltip"
                                                   data-placement="top"
                                                   :title="trans('quiz-creator.show_hide_question_description')"
                                                   class="pointer far fa-eye-slash "></i>
                                            </label>
                                            <div>
                                                <ckeditor class="mt-1 editor-border"
                                                          :editor="editor" v-model="element.description"
                                                          @blur="saveQuestion(element)"
                                                          :config="editorConfig"></ckeditor>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </draggable>
                    </template>
                </form>
            </div>
            <div class="col-2">
            </div>
        </div>
    </div>
</template>

<script>

import draggable from "vuedraggable";
import nestedDraggable from './FormBuilder/NestedDraggable'
import CustomEditor from "../includes/ck-editor/ck-editor-custom";
import UploadAdapter from './UploadAdapter';

let idSection = 1;
export default {
    name: "nested-example",
    display: "Nested",
    order: 15,
    components: {
        draggable, nestedDraggable,
    },
    created() {
        const url = window.location.pathname;
        let id = parseInt(url.substring(url.lastIndexOf('/') + 1));
        // console.log('created', this.qId);

        setTimeout(function () {
            $('[data-toggle="tooltip"]').tooltip();
        }, 100);

        if (typeof this.qId != 'undefined' && this.qId) {
            this.form.id = this.qId;
            this.getQuiz();
            return;
        }

        if (id && Number.isInteger(id)) {
            this.form.id = id;
            this.getQuiz();
        }
    },
    props: {
        qId: Number,
        showDescriptionBlock: {
            type: Boolean,
            default: false
        },
        qName: String,
        sid: Number,
        sections: Array,
    },
    watch: {
        // qId: function(newVal, oldVal) {
        //    this.form.id =  newVal;
        // }
        showDescriptionBlock: function (newVal, oldVal) {
            this.openDescription = !this.openDescription;
        },
        qName: function (newVal, oldVal) {
            this.form.quizName = newVal;
        }
    },
    computed: {
        questionPoints: function () {
            return this.questions.filter(question => question.show_title)
                .reduce(function (sum, question) {
                    return sum + parseInt(question.points || 0);
                }, 0);
        }
    },
    data: function () {
        return {
            openDescription: false,
            showSection: false,
            loader: false,

            quizDescriptionLenght: null,
            quizDescriptionType: null,
            questionsTypes: [
                {
                    name: trans['quiz-creator']['single_choice_question'],
                    id: 1,
                    type: 'single',
                    class: '/images/question-icons/Single Choice - Inactive.svg',
                    active: '/images/question-icons/Single Choice - Active.svg'
                },
                {
                    name: trans['quiz-creator']['multiple_choice_question'],
                    id: 2,
                    type: 'multiple',
                    class: '/images/question-icons/Multiple Choice - Inactive-01.svg',
                    active: '/images/question-icons/Multiple Choice - Active-01.svg'
                },
                {
                    name: trans['quiz-creator']['true_false_question'],
                    id: 3,
                    type: 'true',
                    class: '/images/question-icons/True False - Inactive-01.svg',
                    active: '/images/question-icons/True False - Active-01.svg'
                },
                {
                    name: trans['quiz-creator']['essay_question'],
                    id: 4,
                    type: 'essay',
                    class: '/images/marLMS-quizz-essay-question.png'
                },
                {
                    name: trans['quiz-creator']['reorder_text_question'],
                    id: 6,
                    type: 'reorder',
                    class: '/images/question-icons/Reorder Text - Inactive-01.svg',
                    active: '/images/question-icons/Reorder Text - Active-01.svg'
                },
                {
                    name: trans['quiz-creator']['reorder_image_question'],
                    id: 7,
                    type: 'reorder_images',
                    class: '/images/question-icons/Reorder Image - Inactive-01.svg',
                    active: '/images/question-icons/Reorder Image - Active-01.svg'
                },
                {
                    name: trans['quiz-creator']['free_text_question'],
                    id: 8,
                    type: "free_text",
                    class: '/images/question-icons/Factual - Inactive-01.svg',
                    active: '/images/question-icons/Factual - Active-01.svg'
                },
            ],
            questions: [],
            map: [],
            form: {
                id: null,
                quizName: '',
                quizDescription: '',
                quizBlocks: '',
                questions: [],
                quiz_type: 'quiz',
                showDescription: null,
                repeat_times: 0,
                show_solutions: false,
                show_exam_in_content: false,
                required_graduation: true,
                exam_set_clock: false,
                min_score: false,
                min_score_type: 'percent',
                time: "",
                exam_trainer_close: false,
                is_private: false,
                delay_results_for_minutes: 0,
            },
            editor: CustomEditor,
            editorConfig: {
                extraPlugins: [this.uploader],
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'http://',
                },
            },
        }
    },
    mounted() {
        // this.getLayoutSettings();
        this.openDescription = this.showDescriptionBlock
    },
    methods: {
        uploader(editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return new UploadAdapter(loader);
            };
        },
        changeQuizType: function (type) {
            this.form.quiz_type = type;
            this.change();
        },
        fixMinScore() {
            if (this.form.min_score_type === 'percent' && parseInt(this.form.min_score) > 100) {
                this.form.min_score = 100;
            } else if (this.form.min_score_type === 'points' && parseInt(this.form.min_score) > 1000) {
                this.form.min_score = 1000;
            }
        },
        change: function (editor = false, reload = true, loader = true) {
            this.fixMinScore()
            let $end = '/api/save-quiz';
            this.$data.loader = loader;
            // console.log(this.form);

            this.form.questions = [];
            this.form.questions.push(this.questions);

            axios.post($end, this.form).then(response => {
                if (typeof response.data.redirect != 'undefined') {
                    window.location.href = response.data.redirect;
                }
                this.$data.loader = false;
                if (reload) {
                    this.getQuiz();
                }
                if (editor) {
                    $('#editor-' + editor).toggle();
                }
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        quizChange: function () {
            if (this.form.quizName != "") {
                this.showSection = true;
            }

            if (this.form.id) {
                this.change();
            }
        },
        cloneSection({id, type}) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50);
            return {
                id: 0,
                name: '',
                description: '',
                type: type
            };
        },
        getQuiz: function () {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50);
            let $end = '/api/get-quiz-api/' + this.form.id;
            let self = this;

            axios.get($end).then(function (response) {
                response = response.data;
                self.showSection = true;

                self.form.quizName = response.name;
                self.form.quizDescription = response.description;
                self.form.quizBlocks = JSON.parse(response.content);
                self.form.showDescription = response.show_description;
                self.form.quiz_type = response.quiz_type;
                self.form.repeat_times = response.repeat_times;
                self.form.show_solutions = response.show_solutions;
                self.form.show_exam_in_content = response.show_exam_in_content;
                self.form.required_graduation = response.required_graduation;
                self.form.time = response.time;
                self.form.exam_set_clock = response.exam_set_clock;
                self.form.min_score = response.min_score;
                self.form.min_score_type = response.min_score_type ? response.min_score_type : 'percent';
                self.form.exam_trainer_close = response.exam_trainer_close;
                self.form.is_private = response.is_private;
                self.form.delay_results_for_minutes = response.delay_results_for_minutes;

                self.questions = [];
                self.map = response.questions;
                // console.log(self.form.quizBlocks);

                response.questions.forEach(function (question) {
                    let data = {
                        name: question.name,
                        description: question.description,
                        id: question.id,
                        type: question.type,
                        points: question.points,
                        show_title: question.show_title,
                        show_description: question.show_description,
                        contentOpen: false,
                        pointsOpen: false
                    }
                    self.questions.push(data);
                });
                setTimeout(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 100);

                if (self.form.quiz_type === 'essay') {
                    self.openDescription = true;
                }
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        removeSection(id, event) {
            this.$swal.fire({
                title: event.currentTarget.getAttribute('data-confirm-title'),
                icon: 'warning',
                html: event.currentTarget.getAttribute('data-confirm-message'),
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    this.questions.splice(id, 1);
                    this.change()
                }
            });
        },
        toggleEditor(id, idx) {
            if (typeof this.questions[idx].showQuestions != 'undefined') {
                delete this.questions[idx].showQuestions;
            } else {
                this.questions[idx].showQuestions = true;
            }
            this.$forceUpdate();
        },
        openEditor(idx) {
            this.questions[idx].showQuestions = true;
            this.$forceUpdate();
        },
        // getLayoutSettings: function () {
        //     let $end = '/api/get-layout-settings/1';
        //     let self = this;
        //     axios.get($end).then(function (res) {
        //         self.quizDescriptionLenght = res.data.quiz_description_lenght;
        //         self.quizDescriptionType = res.data.quiz_description_type;
        //     }).catch(err => {
        //         console.log(err);
        //         this.$data.loader = false;
        //     });
        // },
        // limitDescription: function () {
        //     if (this.quizDescriptionType == 'words') {
        //         let words = this.form.quizDescription.match(/\S+/g).length;
        //
        //         if (words > this.quizDescriptionLenght) {
        //             let trimmed = this.form.quizDescription.split(/\s+/, 10).join(" ");
        //             this.form.quizDescription = trimmed + " ";
        //         }
        //
        //     }
        // },
        toggleDescription: function () {
            this.openDescription = !this.openDescription;
            console.log(this.openDescription);
        },
        toggleQuestionDescription: function (id) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip();
            }, 100);
            this.questions[id].contentOpen = this.questions[id].contentOpen ? false : true;
            this.questions[id].pointsOpen = false;
        },
        toggleQuestionPoints: function (id) {
            this.questions[id].pointsOpen = this.questions[id].pointsOpen ? false : true;
            this.questions[id].contentOpen = false;
        },
        saveQuestion: function (data) {
            let $end = '/api/save-questions';

            let self = this;

            axios.post($end, {
                data: data,
                questionId: data.id,
            }).then(response => {

            }).catch(err => {
                this.$data.loader = false;
            });
        },
        showQuestionTitle: function (id, data) {
            this.questions[id].show_title = !this.questions[id].show_title;
            this.saveQuestion(data);
        },
        showQuestionDescription: function (id, data) {
            this.questions[id].show_description = !this.questions[id].show_description;
            this.saveQuestion(data);
        },
        getQuestionName: function (type) {
            let name;
            switch (type) {
                case 'single':
                    name = trans['quiz-creator']['single_choice_question'];
                    break;
                case 'multiple':
                    name = trans['quiz-creator']['multiple_choice_question'];
                    break;
                case 'true':
                    name = trans['quiz-creator']['true_false_question'];
                    break;
                case 'essay':
                    name = trans['quiz-creator']['essay_question'];
                    break;
                case 'reorder':
                    name = trans['quiz-creator']['reorder_text_question'];
                    break;
                case 'reorder_images':
                    name = trans['quiz-creator']['reorder_image_question'];
                    break;
                case 'free_text':
                    name = trans['quiz-creator']['free_text_question'];
                    break;
                default:
                    name = trans['quiz-creator']['question'];
                    break;
            }
            return name;
        },
        updateBlocks(element) {
            this.$emit('update-blocks', element);
        }
    }
}
</script>
<style type="text/css">
.custom-dropdown {
    right: 2rem;
}
</style>
